import _ from 'lodash';
import React, { createContext, useEffect, useState, useMemo } from 'react';
// STATE
import { initialState, childrenState, professionalTabDefaultForm } from '../state/const';
// API
import { getDoctorList } from '../../../api/mdProfileApi';

export const useMdProfileContext = createContext();

export default function MdProfileProvider({ children }) {
  const defaultFilterForm = {
    team: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    manager_id: { label: 'ALL', value: null },
    group: { label: 'ALL', value: null },
    doctor_id: { label: 'ALL', value: null },
  };

  // FORM
  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [form, setForm] = useState({
    ...initialState,
    childrens: [childrenState],
  });
  const [professionalform, setProfessionalform] = useState(professionalTabDefaultForm);

  // STATE
  const [uniq, setUniq] = useState(null);
  const [editable, setEditable] = useState(false);
  const [viewProfile, setViewProfile] = useState({
    toggle: false,
    loading: false,
    doctor_id: null,
    doctor: {},
  });
  const [mdList, setMdList] = useState({ loading: false, data: [] });

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleGenerateReport = async () => {
    setMdList({ ...mdList, loading: true });
    const request = {
      team: [filterForm?.team?.value],
      rep_id: [filterForm?.rep_id?.value],
      manager_id: [filterForm?.manager_id?.value],
      group: [filterForm?.group?.value],
      md_id: [filterForm?.doctor_id?.value],
    };

    const response = await getDoctorList(request);
    const { code, data } = response.data;

    if (code === '200') {
      const newArrList = data?.map((row) => {
        const clinic = row?.clinic.find((item) => item.is_primary === true);

        return {
          id: row?.id,
          md_id: row?.basic_info_md_profile_id,
          name: row?.basic_info_name,
          specialty: row?.specialty,
          primary_clinic: clinic?.name,
          best_day_to_cover: clinic?.best_day_to_cover,
          clinic_hour: clinic?.best_time_to_cover,
          md_image: row?.md_image,
        };
      });

      setMdList({
        ...mdList,
        loading: false,
        data: newArrList,
      });
    }
  };

  const handleClearReport = () => {
    setFilterForm(defaultFilterForm);
    setUniq(_.uniqueId());
  };

  const handleViewProfile = (md_id, row) => {
    setViewProfile({ ...viewProfile, toggle: true, doctor_id: md_id, doctor: row });
  };

  useEffect(() => {
    handleGenerateReport();
  }, [uniq]);

  const value = useMemo(
    () => ({
      // DATA
      mdList,
      form,
      filterForm,
      defaultFilterForm,
      viewProfile,
      editable,
      professionalTabDefaultForm,
      professionalform,
      // STATE
      setForm,
      setFilterForm,
      setViewProfile,
      setEditable,
      setProfessionalform,
      // FUNCTION
      handleChangeFilter,
      handleGenerateReport,
      handleClearReport,
      handleViewProfile,
    }),
    [viewProfile, mdList, filterForm, form, professionalform],
  );
  return <useMdProfileContext.Provider value={value}>{children}</useMdProfileContext.Provider>;
}
